/*
 * subscribe-cart.js
 * -------------------------------------------------------------------------
 * Powers the "Subscribe your Goldbacks & save" cart toggle
 * (snippets/subscribe-cart-toggle.liquid).
 *
 * On toggle ON:  every eligible line (Goldback Stack selling-plan product)
 *                is converted to a subscription at the chosen cadence via
 *                sequential /cart/change.js calls, then the cart re-renders.
 * On toggle OFF: eligible lines revert to one-time (selling_plan: null).
 * On cadence change (while ON): re-applies the new plan id to eligible lines.
 *
 * Ineligible lines (bundles/accessories) are never touched — mixed cart,
 * Loop splits recurring vs one-time at checkout.
 *
 * Works on both the cart page and the cart drawer. Uses the Shopify Section
 * Rendering API to refresh cart UI without a full reload.
 */
(function () {
  'use strict';

  var CADENCE_KEYS = { monthly: 'planMonthly', every2: 'planEvery2', every3: 'planEvery3' };

  function SubscribeCart(el) {
    this.el = el;
    this.check = el.querySelector('[data-sub-check]');
    this.cadenceWrap = el.querySelector('[data-sub-cadence]');
    this.cadenceBtns = Array.prototype.slice.call(el.querySelectorAll('[data-cadence]'));
    this.errorEl = el.querySelector('[data-sub-error]');
    this.cadence = 'monthly';
    this.lines = this.readLines();
    this.plans = {
      monthly: parseInt(el.getAttribute('data-plan-monthly'), 10),
      every2: parseInt(el.getAttribute('data-plan-every2'), 10),
      every3: parseInt(el.getAttribute('data-plan-every3'), 10)
    };
    this.bind();
  }

  SubscribeCart.prototype.readLines = function () {
    var script = this.el.querySelector('.sub-cart__lines');
    if (!script) return [];
    try { return JSON.parse(script.textContent) || []; } catch (e) { return []; }
  };

  SubscribeCart.prototype.bind = function () {
    var self = this;
    if (this.check) {
      this.check.addEventListener('change', function () {
        if (self.check.checked) { self.showCadence(true); self.apply(self.plans[self.cadence]); }
        else { self.showCadence(false); self.apply(null); }
      });
    }
    this.cadenceBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.setCadence(btn.getAttribute('data-cadence'));
      });
    });
  };

  SubscribeCart.prototype.showCadence = function (show) {
    if (this.cadenceWrap) this.cadenceWrap.hidden = !show;
  };

  SubscribeCart.prototype.setCadence = function (cadence) {
    if (!CADENCE_KEYS[cadence]) return;
    this.cadence = cadence;
    this.cadenceBtns.forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-cadence') === cadence ? 'true' : 'false');
    });
    // If the toggle is on, re-apply the new plan immediately.
    if (this.check && this.check.checked) this.apply(this.plans[cadence]);
  };

  SubscribeCart.prototype.showError = function (msg) {
    if (!this.errorEl) return;
    this.errorEl.textContent = msg;
    this.errorEl.hidden = false;
  };
  SubscribeCart.prototype.hideError = function () {
    if (this.errorEl) { this.errorEl.hidden = true; this.errorEl.textContent = ''; }
  };

  // Sequentially set (or clear) the selling plan on every eligible line.
  SubscribeCart.prototype.apply = function (planId) {
    var self = this;
    var targets = this.lines.filter(function (l) { return l.eligible; });
    if (!targets.length) return;

    this.hideError();
    this.el.setAttribute('aria-busy', 'true');

    var chain = Promise.resolve();
    targets.forEach(function (line) {
      chain = chain.then(function () {
        return self.changeLine(line.key, line.qty, planId);
      });
    });

    chain
      .then(function (cart) {
        self.el.removeAttribute('aria-busy');
        self.refreshSections(cart);
      })
      .catch(function (err) {
        self.el.removeAttribute('aria-busy');
        self.showError((err && err.message) || 'Could not update your cart. Please try again.');
        // Revert the checkbox to reflect reality.
        if (self.check) self.check.checked = !!planId ? false : true;
        self.showCadence(self.check && self.check.checked);
      });
  };

  SubscribeCart.prototype.changeLine = function (key, qty, planId) {
    // Always pass quantity: /cart/change.js resets qty to 1 when a line's
    // selling_plan changes unless quantity is explicitly preserved.
    var body = { id: key, quantity: qty, selling_plan: planId === null ? '' : planId };
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'Cart update failed.');
        return data;
      });
    });
  };

  // Reload to guarantee correct recurring state everywhere (line badges,
  // totals, drawer, and any Loop/theme shipping perk logic). Reliability > flash.
  SubscribeCart.prototype.refreshSections = function () {
    window.location.reload();
  };

  function init() {
    var nodes = document.querySelectorAll('[data-subscribe-cart]');
    Array.prototype.forEach.call(nodes, function (el) {
      if (el._subInit) return;
      el._subInit = true;
      new SubscribeCart(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-init when the drawer re-renders its contents.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('cart:refresh', init);
})();
